'use strict'

import bus from '@/bus'
import { store } from '@/store'

if (!window.EventSource) {
  require('event-source-polyfill')
}

const evtFactory = (onError, onMessage) => {
  const es = new EventSource('/api/private/stats/stream', {
    withCredentials: true
  })
  es.onerror = onError
  es.onmessage = onMessage

  busSubscribe()
  return es
}

const reconnect = () => {
  if (evtSource) evtSource.close()

  if (store.getters.isAuthenticated) {
    evtSource = evtFactory(onError, onMessage)
    busSubscribe()
  }
}

const onError = err => {
  console.error('Error in stats', err)
  busLeave()
  setTimeout(reconnect, 10000)
}

const onMessage = msg => {
  bus.emit(`stream/stats/${msg.lastEventId}`, msg)
}

const busSubscribe = () => {
  bus.subscribe(this, 'stream/stats/followers', async event => {
    store.dispatch('handleFollowerEvent', event)
  })
}

const busLeave = () => {
  bus.leave(this)
}

let evtSource = evtFactory(onError, onMessage)



// WEBPACK FOOTER //
// ./src/stats.js